import React from "react";
import { lightThemeColors } from "../../assets/style/colors";
import styled from "styled-components";
import { motion } from "framer-motion";
import { ReactComponent as MessagingIcon } from "../../assets/icons/criticalMoment/message.svg";
import { ReactComponent as Unified } from "../../assets/icons/criticalMoment/unified.svg";
import { ReactComponent as MissedAlerts } from "../../assets/icons/criticalMoment/missedAllerts.svg";
import { ReactComponent as Customization } from "../../assets/icons/criticalMoment/customization.svg";
import { ReactComponent as Engagement } from "../../assets/icons/criticalMoment/engagement.svg";

import CriticalMomentItem from "./CriticalMomentItem";
const CriticalMoment = () => {
  const moments = [
    {
      icon: <MessagingIcon />,
      title: "Consistent Messaging",
      description:
        "Ensure users never miss important alerts, whether on mobile or web.",
    },
    {
      icon: <Unified />,
      title: "Unified System",
      description:
        "Bringing all your messaging tools into one unified platform.",
    },
    {
      icon: <MissedAlerts />,
      title: "Reduced Missed Alerts",
      description:
        "Guarantee your messages are seen and acted upon, reducing missed opportunities.",
    },
    {
      icon: <Customization />,
      title: "Full Customization",
      description:
        "Personalize your messages to match your brand’s tone, style, and content.",
    },
    {
      icon: <Engagement />,
      title: "Increased Engagement",
      description:
        "Maximize message visibility and user interaction across all channels.",
    },
  ];
  return (
    <FullPageContainer>
      <Container id={"criticalMoment"}>
        <Line>
          <TextWrapper>
            <Title>Never Miss a Critical Moment</Title>
            <Subtitle>
              Without Cross-App Messaging, you risk missing critical
              communication moments. Time-sensitive messages can be overlooked,
              leading to frustrated users, lower satisfaction, and decreased
              engagement.
            </Subtitle>
          </TextWrapper>
        </Line>
        <ItemsContainer>
          {moments.map((item, index) => (
            <CriticalMomentItem
              key={index}
              title={item.title}
              svg={item.icon}
              description={item.description}
            />
          ))}
        </ItemsContainer>
      </Container>
    </FullPageContainer>
  );
};

export default CriticalMoment;

const FullPageContainer = styled.div`
  display: flex;
  width: 100%;
  background: ${lightThemeColors.background};
  position: relative;
`;

const Container = styled.div`
  width: 100%;
  max-width: 1512px;
  margin-left: auto;
  margin-right: auto;
  z-index: 1;
  display: flex;
  flex-direction: column;
padding:100px 80px;
  gap: 100px;
  @media (max-width: 990px) {
    padding: 20px;
    gap: 30px;
  }
`;

const Title = styled.h1`
  color: ${lightThemeColors.darkColor};
  font-size: 36px;
  font-weight: 700;
  line-height: 46px;
  text-align: center;
  @media (max-width: 990px) {
    font-size: 30px;
    line-height: 36px;
    text-align: center;
  }
`;
const Subtitle = styled.p`
  color: ${lightThemeColors.darkColorFaded};
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
  text-align: center;
  @media (max-width: 990px) {
    font-size: 18px;
    line-height: 24px;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 30px;
  max-width: 850px;
  margin: auto;
  @media (max-width: 990px) {
    max-width: unset;
  }
`;
const Line = styled(motion.div)`
  display: flex;
  align-items: center;
  gap: 25px;
  @media (max-width: 990px) {
    gap: 30px;
    flex-direction: column;
  }
`;
const ItemsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 20px;
  row-gap: 50px;
  justify-content: start;
  @media (max-width: 990px) {
    row-gap: 30px;
  }
`;
